export enum AccessPaths {
  Content = 'content',
}
